export interface CommentProps {
  name: string;
}
